
export default {
  name: "default",
  middleware: ["signup-redirect"],
  data() {
    return {};
  }
};
